<template>
  <div class="d-flex align-center">
    <ClosdFildersIcon :document="document" size="20"/>

    <div class="document-name">
      <AppDownloadFile class="document-link" :link="fileLink">
        <template #default="{ submitForm }">
          <TruncatedText @click="submitForm">
            <template v-if="document.numbering">
              {{ document.numbering }}&nbsp;
            </template>
            {{ documentName }}
          </TruncatedText>
        </template>
      </AppDownloadFile>
      <app-badge v-if="isDocumentMultiVersions">
        {{ `v${document.version}` }}
      </app-badge>
    </div>
  </div>
</template>

<script lang="ts" setup>
import axios from 'axios'
import { computed } from 'vue'
import { useStore } from 'vuex'

import AppDownloadFile from '@/common/AppDownloadFile.vue'
import ClosdFildersIcon from '@/common/filders/ClosdFildersIcon.vue'
import TruncatedText from '@/common/TruncatedText.vue'
import { type Filder } from '@/project/documents/types'

const props = defineProps<{
  document: Filder,
}>()

const documentName = computed(() => props.document.basename || props.document.name || '')
const isDocumentMultiVersions = computed(() => (props.document?.nbVersions ?? 0) > 1)

const store = useStore()
const fileLink = computed(() => `${axios.defaults.baseURL}/room/${store.getters['room/roomMnemo']}/downloads/file/${props.document.id}`)
</script>

<style scoped lang="scss">
.document-name {
  width: 130px;
  display: flex;
  align-items: center;
  line-height: 20px;
  font-size: 14px;
  font-weight: 400;
  color: rgb(var(--v-theme-grey--900));
}
.document-link {
  width: 100%;
}
</style>
